import { MediaProgramGuide } from '@calm/evexia-web-sdk';

export enum AudioEvent {
    LoadedMetadata = 'loadedmetadata',
    Play = 'play',
    Pause = 'pause',
    Ended = 'ended',
    TimeUpdate = 'timeupdate',
    Progress = 'progress',
    Seeked = 'seeked',
}

export enum VideoEvent {
    LoadedMetadata = 'loadedmetadata',
    Play = 'play',
    Pause = 'pause',
    Ended = 'ended',
    TimeUpdate = 'timeupdate',
    Progress = 'progress',
    Seeked = 'seeked',
}

export enum MediaType {
    Audio = 'audio',
    Video = 'video',
    Unknown = 'unknown',
}

export const MediaEvent = { ...AudioEvent, ...VideoEvent };
export type MediaEvent = AudioEvent | VideoEvent;

export const CALM_PUBLIC_ASSETS_URLS: string[] = process.env
    .NEXT_PUBLIC_CALM_PUBLIC_ASSETS_BASEURLS
    ? JSON.parse(process.env.NEXT_PUBLIC_CALM_PUBLIC_ASSETS_BASEURLS)
    : ['https://assets.calm.com'];

export function needsMediaCredentials(src: string) {
    return !CALM_PUBLIC_ASSETS_URLS.some((publicUrl) =>
        src.includes(publicUrl)
    );
}

export function displayTime(s: number) {
    const hours = Math.floor(s / 3600);
    const minutes = Math.floor((s % 3600) / 60);
    const seconds = Math.floor(s % 60);
    return `${hours ? hours + ':' : ''}${
        hours && minutes < 10 ? '0' + minutes : minutes
    }:${seconds < 10 ? '0' + seconds : seconds}`;
}

export function getMediaType(guide: MediaProgramGuide): MediaType {
    for (const { type } of guide.assets) {
        if (type === 'audio') {
            return MediaType.Audio;
        }

        if (type === 'video') {
            return MediaType.Video;
        }
    }

    return MediaType.Unknown;
}

// For some reason we cannot use the URL constructor in jest/node so we are implementing it manually
export function getM3U8ProxyUrl(url: string, credentials: string) {
    const urlParts = url.split('?');
    const pathname = urlParts[0].split('/').slice(3).join('/');
    return `${process.env.NEXT_PUBLIC_CALM_API_BASEURL}/content/caas/m3u8/${pathname}?${credentials}`;
}
